import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { useCourseStore } from "../../hooks/useCourseStore";
import { Course } from "../../types/slices/coursesType";
import { CreateEditCourseModal } from "./components/CreateEditCourseModal";

const columns = [
  { type: "options", field: "options", label: "Opciones" },
  { type: "text", field: "name", label: "NOMBRE" },
  { type: "text", field: "code", label: "CÓDIGO" },
  { type: "text", field: "n_modules", label: "N° MODULOS" },
  { type: "text", field: "n_academic_hours", label: "N° HRS. ACADEMICAS" },
  { type: "detail", field: "", label: "" },
];

const Courses: FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [rowSelected, setRowSelected] = useState<Course>({} as Course);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    courses,
    statusCourses,
    openModal,
    getCourses,
    getCoursesSearch,
    setSelectedCourse,
    deleteCourse,
    setOpenModal,
    setEditCourse,
    changeIsEdit,
  } = useCourseStore();

  useEffect(() => {
    setLoading(true);
    getCourses().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditCourse(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const onDetails = (rowSelected) => {
    setSelectedCourse(rowSelected);
    navigate(RoutesMap.MODULES_OF_COURSES);
  };

  const onDeleteConfirm = async () => {
    const response = await deleteCourse(rowSelected?.id || 0);
    if (response === true) {
      setSelectedCourse({} as Course);
      setModalDeleteConfirm(false);
      getCourses();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getCoursesSearch(value);
    }
    if (value.length === 0) {
      getCourses();
    }
  };

  return (
    <>
      {statusCourses === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Cursos"}
          columns={columns}
          loading={loading}
          rows={courses || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          onDetails={onDetails}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={statusCourses}
        />
      )}
      {openModal && <CreateEditCourseModal />}
    </>
  );
};

export default Courses;
